<!-- Header -->
<mat-card class="min">
  <mat-card-header class="flex-space center" style="border-bottom: 1px lightgray">
    <div class="header-container">
      <div class="left-content">
        <span class="header-text">Create Cylinders</span>
      </div>
      <button mat-icon-button class="close-button" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card-header>
</mat-card>

<!-- Content -->
<mat-card-content class="margin padding all">
  <form [formGroup]="crossKeyRangeForm" (keyup.enter)="submit()">
    <!-- Prefix -->
    <div class="row">
      <mat-form-field floatLabel="always" appearance="outline" class="full-width">
        <mat-label
          for="prefix"
          [ngClass]="{
            'error-message': fieldHasError(crossKeyRangeForm, 'prefix'),
            focus: focus.prefix
          }"
        >
          Prefix
        </mat-label>
        <input
          id="prefix"
          class="uppercase"
          [ngClass]="{
            error: fieldHasError(crossKeyRangeForm, 'prefix'),
            disabled: false,
            'focus-border': focus.prefix
          }"
          maxlength="10"
          placeholder="Enter Prefix"
          formControlName="prefix"
          (input)="onAlphanumericInput($event, 'prefix')"
          (focus)="focusOn('prefix')"
          (focusout)="focusOn('prefix')"
          aria-describedby="prefix errors"
          cdkFocusInitial
          matInput
        />

        <mat-icon *ngIf="fieldHasError(crossKeyRangeForm, 'prefix')" [size]="24" [iconName]="'warning'" [color]="'#EE6352'">
        </mat-icon>

        <!-- Errors -->
        <div *ngFor="let validation of errorMessages.prefix" id="prefixErrors">
          <div class="caption error-message" *ngIf="fieldHasErrorMessages(crossKeyRangeForm, validation, 'prefix')">
            {{ validation.message }}
          </div>
        </div>
      </mat-form-field>
    </div>

    <!-- from -->
    <div class="row">
      <mat-form-field floatLabel="always" appearance="outline" class="full-width">
        <mat-label
          for="from"
          [ngClass]="{
            'error-message': fieldHasError(crossKeyRangeForm, 'from'),
            focus: focus.from
          }"
        >
          From <span *ngIf="lastCrossKey?.keySetSymbol">( Last used: {{ lastCrossKey?.keySetSymbol }} )</span>
        </mat-label>
        <input
          id="from"
          class="uppercase"
          [ngClass]="{
            error: fieldHasError(crossKeyRangeForm, 'from'),
            disabled: false,
            'focus-border': focus.from
          }"
          maxlength="10"
          placeholder="Enter From"
          formControlName="from"
          (input)="onFromToInput($event, 'from')"
          (focus)="focusOn('from')"
          (focusout)="focusOn('from')"
          aria-describedby="from errors"
          matInput
        />

        <mat-icon *ngIf="fieldHasError(crossKeyRangeForm, 'from')" [size]="24" [iconName]="'warning'" [color]="'#EE6352'">
        </mat-icon>

        <!-- Errors -->
        <div *ngFor="let validation of errorMessages.from" id="fromErrors">
          <div class="caption error-message" *ngIf="fieldHasErrorMessages(crossKeyRangeForm, validation, 'from')">
            {{ validation.message }}
          </div>
        </div>
      </mat-form-field>
    </div>

    <!-- to -->
    <div class="row">
      <mat-form-field floatLabel="always" appearance="outline" class="full-width">
        <mat-label
          for="to"
          [ngClass]="{
            'error-message': fieldHasError(crossKeyRangeForm, 'to'),
            focus: focus.to
          }"
        >
          To
        </mat-label>
        <input
          id="to"
          class="uppercase"
          [ngClass]="{
            error: fieldHasError(crossKeyRangeForm, 'to'),
            disabled: false,
            'focus-border': focus.to
          }"
          maxlength="10"
          placeholder="Enter To"
          formControlName="to"
          (input)="onFromToInput($event, 'to')"
          (focus)="focusOn('to')"
          (focusout)="focusOn('to')"
          aria-describedby="to errors"
          min="0"
          cdkFocusInitial
          matInput
        />

        <mat-icon *ngIf="fieldHasError(crossKeyRangeForm, 'to')" [size]="24" [iconName]="'warning'" [color]="'#EE6352'">
        </mat-icon>

        <!-- Errors -->
        <div *ngFor="let validation of errorMessages.to" id="toErrors">
          <div class="caption error-message" *ngIf="fieldHasErrorMessages(crossKeyRangeForm, validation, 'to')">
            {{ validation.message }}
          </div>
        </div>
      </mat-form-field>
    </div>

    <!-- Suffix -->
    <div class="row">
      <mat-form-field floatLabel="always" appearance="outline" class="full-width">
        <mat-label
          for="suffix"
          [ngClass]="{
            'error-message': fieldHasError(crossKeyRangeForm, 'suffix'),
            focus: focus.suffix
          }"
        >
          Suffix
        </mat-label>
        <input
          id="suffix"
          class="uppercase"
          [ngClass]="{
            error: fieldHasError(crossKeyRangeForm, 'suffix'),
            disabled: false,
            'focus-border': focus.suffix
          }"
          maxlength="10"
          placeholder="Enter Suffix"
          formControlName="suffix"
          (input)="onAlphanumericInput($event, 'suffix')"
          (focus)="focusOn('suffix')"
          (focusout)="focusOn('suffix')"
          aria-describedby="suffix errors"
          cdkFocusInitial
          matInput
        />

        <mat-icon *ngIf="fieldHasError(crossKeyRangeForm, 'suffix')" [size]="24" [iconName]="'warning'" [color]="'#EE6352'">
        </mat-icon>

        <!-- Errors -->
        <div *ngFor="let validation of errorMessages.suffix" id="suffixErrors">
          <div class="caption error-message" *ngIf="fieldHasErrorMessages(crossKeyRangeForm, validation, 'suffix')">
            {{ validation.message }}
          </div>
        </div>
      </mat-form-field>
    </div>
  </form>
</mat-card-content>

<!-- Buttons -->
<mat-card-actions>
  <div class="row">
    <button mat-stroked-button id="cancel" (click)="close()"> Cancel </button>
    <button
      mat-flat-button
      class="margin left"
      color="primary"
      id="save"
      (click)="submit()"
      [disabled]="!crossKeyRangeForm.valid"
    >
      Create
    </button>
  </div>
</mat-card-actions>
